import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import FiscalConfigContainer from './financial/fiscal/config/FiscalConfigContainer';
import ProduttivoMuiTheme from '../components/shared/themes/ProduttivoTheme';

const fiscalSettings = document.getElementById('fiscal_settings-container');

if (fiscalSettings !== null) {
  const root = createRoot(fiscalSettings);

  root.render(
    <ThemeProvider theme={ProduttivoMuiTheme}>
      <FiscalConfigContainer />
    </ThemeProvider>
  );
}